import API from '../dataApi';

// -- Accounting: Ledger Sub-Groups (under categories — user-creatable) --------
export const getLedgerSubGroups = (derasarId, ledgerGroupId) =>
  API.get('/ledger-sub-groups', { params: { derasarId, ...(ledgerGroupId ? { ledgerGroupId } : {}) } });
export const createLedgerSubGroup = (data) => API.post('/ledger-sub-groups', data);
export const updateLedgerSubGroup = (id, data) => API.put(`/ledger-sub-groups/${id}`, data);
export const deleteLedgerSubGroup = (id) => API.delete(`/ledger-sub-groups/${id}`);
